import React from 'react';
import commonStrings from 'resources/commonStrings';
import styles from './ReportsQueueTable.module.css';

function ReportsQueueNoData() {
  const headerClasses = `nwea-ds-v1-typography-body-copy-large ${styles['no-data']}`;
  return <div className={headerClasses}>{commonStrings.queue.noReportsInQueue}</div>;
}
export default ReportsQueueNoData;
